import React from "react";
import "./ScalabilityHero.css";

export default function ScalabilityHero() {
  return (
    <div id="scalability-hero" className="outsourcemainclass">
      <div className="left">
        <h1>DevOps Scalability Services</h1>
        <p>
         Enable seamless growth with BastionEx’s DevOps Scalability services, delivering secure, high-performance architectures that handle increasing workloads while maintaining reliability across cloud, hybrid, and on-premises environments.
        </p>
        <button>Let's Discuss Your Project</button>
      </div>
    </div>
  );
}
